import React, { useContext } from 'react'; 
import { Card, CardContent, CardHeader, Typography, Tooltip, makeStyles } from "@material-ui/core";
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { DataContext } from '../../../../data/DataContext';
import {useTranslation} from "react-i18next";
import {getVersionData} from "../Data/VersionData";
import PropTypes from 'prop-types';
import './css/versionCardComponent.css';

const VersionCardComponent = ({ title, content, tooltipText }) => {

  const useStyles = makeStyles((theme) => ({
      customTooltip: {
        backgroundColor: "black", 
        color: "white", 
        fontSize: "12px", 
      },
      customArrow:{
        color: "black"
      },
      pdfIcon: {
        fontSize: '36px',
        color: '#2196F3',
      },
    }));

  const classes = useStyles();
  const  {t} = useTranslation();
  // Get current version from context
  const { about } = useContext(DataContext);
  const version = about.serverVersion;
  const currentVersionData = getVersionData(version); 
  console.log("currentVersionData", currentVersionData);

  return (
    <Card data-testid="version-card" className="version-card">
      {/* Title */}
      <CardHeader
        title={
          <div className="card-header-container" data-testid="card-header">
            <Typography variant="h6" data-testid="card-title">
              {title}
            </Typography>
            <Tooltip
              title={tooltipText}
              arrow
              placement="top"
              classes={{ tooltip: classes.customTooltip, arrow: classes.customArrow }}
            >
              <InfoOutlinedIcon
                className="info-icon"
                data-testid="info-icon"
              />
            </Tooltip>
          </div>
        }
      />
      <CardContent data-testid="card-content">
        {currentVersionData && currentVersionData.length > 0 ? (
          currentVersionData.map((version) => (
            <div key={version.version} className="version-entry" data-testid="version-entry">
              <button className="version-button" data-testid="version-button">
                <div className="version-button-content">
                  <div className="version-button-dot"></div>
                  {version.version}
                </div>
              </button>
              <Typography variant="body2" className="version-content" data-testid="version-content">
                {content}
              </Typography>
              <a 
                target="_blank" 
                rel="noopener noreferrer" 
                href={version.pdfLink} 
                data-testid="pdf-link"
                className="pdf-link"
                onMouseEnter={(e) => e.currentTarget.firstChild.style.backgroundColor = '#ebf2f5'}
                onMouseLeave={(e) => e.currentTarget.firstChild.style.backgroundColor = 'transparent'}
              >
                <PictureAsPdfOutlinedIcon className={classes.pdfIcon} />
              </a>
            </div>
          ))
        ) : (
          <Typography variant="body2" className="loading-text" data-testid="loading-text">
            {t('loading__')}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

VersionCardComponent.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
};



export default VersionCardComponent;